import { debounce } from 'lodash'
import { useEffect } from 'react'
import { FilterObject } from 'app/filter.utils'

export default function BetweenFilter({
  filter,
  value,
  onValueChange,
}: {
  filter: FilterObject
  value?: string | string[]
  onValueChange: (val: string[]) => void
}) {
  let values: string[] = []
  useEffect(() => {
    if (typeof value === `string`) {
      // oxlint-disable-next-line react/immutability -- existing closure or mutable API pattern is intentional
      values = [value, (+value + 1).toString()]
      document.getElementsByName(filter.attribute).forEach((attr, i) => {
        let input = attr as HTMLInputElement
        input.defaultValue = values[i]
      })
    }
  }, [])
  let handleChange = () => {
    document.getElementsByName(filter.attribute).forEach((attr, i) => {
      let input = attr as HTMLInputElement
      if (i === 1 && input.value <= values[0]) {
        values[i] = (+values[0] + 1).toString()
        input.defaultValue = values[i].toString()
      } else values[i] = input.value
    })
    if (values.length === 2) {
      onValueChange(values)
    }
  }
  return (
    <div className="flex items-center justify-between gap-x-1">
      <input
        name={filter.attribute}
        defaultValue={value?.[0]}
        type="number"
        className="h-8 w-4/5 rounded-lg border border-default bg-surface px-2 text-body-sm"
        onChange={debounce(() => handleChange(), 200)}
        disabled={filter.readOnly}
      />
      <span> & </span>
      <input
        name={filter.attribute}
        defaultValue={value?.[1]}
        type="number"
        className="h-8 w-4/5 rounded-lg border border-default bg-surface px-2 text-body-sm"
        onChange={debounce(() => handleChange(), 200)}
        disabled={filter.readOnly}
      />
    </div>
  )
}
